module.exports = __webpack_public_path__ + "img/pic_kuangjituoguan.418ff51b.png";